/* RAVOOY vehicle search: load one make after selection, cache only in this tab. */
(function () {
  'use strict';
  if (window.__RVY_LAZY_SEARCH__) return;
  window.__RVY_LAZY_SEARCH__ = true;
  function mount() {
    const root = document.getElementById('vehicle-search');
    if (!root) return false;
    const config = window.RAVOOY_FITMENT_CONFIG;
    const fields = ['year','make','model','trim'].map(k => root.querySelector('#sel-' + k));
    const button = root.querySelector('.search-btn'), card = root.querySelector('.search-card');
    if (!button || !card || fields.some(f => !f)) return false;
    const [year, make, model, trim] = fields;
    let status = root.querySelector('#rvy-fitment-status');
    if (!status) { status = document.createElement('p'); status.id='rvy-fitment-status'; card.append(status); }
    status.setAttribute('role','status'); status.setAttribute('aria-live','polite');
    const results = document.createElement('div'); results.id='rvy-fitment-results'; card.append(results);
    const retry = document.createElement('button'); retry.type='button'; retry.textContent='Retry vehicle search'; retry.hidden=true; card.append(retry);
    const say = s => {status.textContent=s;};
    function reset(el, label) {el.replaceChildren(new Option('Select '+label,''));el.disabled=true;}
    function fill(el, values, label) {reset(el,label);for(const v of values)el.add(new Option(v,v));el.disabled=values.length===0;}
    button.type='button';button.textContent='Find my kit';button.disabled=true;
    fields.forEach((e,i)=>reset(e,['year','make','model','trim'][i]));
    if (!config || config.version!==3 || !config.urls || !config.years || !Array.isArray(config.makes)) {
      say('Vehicle search is temporarily unavailable. Please contact us for your kit.');return true;
    }
    const extraPromise=fetch('https://cdn.shopify.com/s/files/1/0974/5757/0079/files/ravooy-full-front-fitment-2026-09-27-v2.json?v=1790540389',{credentials:'omit',cache:'default'}).then(r=>{if(!r.ok)throw new Error('Full Front catalog response');return r.json();}).catch(()=>({}));
    extraPromise.then(extra=>{
      for(const [name,rows] of Object.entries(extra)){
        let index=config.makes.indexOf(name);
        if(index<0)index=config.makes.push(name)-1;
        for(const row of rows){
          const years=/^(\d{4})(?:-(\d{4}))?/.exec(row[0]);if(!years)continue;
          for(let y=+years[1];y<=+(years[2]||years[1]);y++){
            const key=String(y);if(!config.years[key])config.years[key]=[];
            if(!config.years[key].includes(index))config.years[key].push(index);
          }
        }
      }
      fill(year,Object.keys(config.years).sort((a,b)=>b-a),'year');
      say('Choose your year and make to find your custom pre-cut PPF kit.');
      restoreSelection();
    });
    const redirects={
      'ravooy-full-hood-pre-cut-ppf-kit-for-volkswagen-taos-2025-2026':'ravooy-full-front-pre-cut-ppf-kit-for-volkswagen-taos-2025-2026',
      'ravooy-full-hood-pre-cut-ppf-kit-for-volkswagen-golf-r-2025':'ravooy-full-front-pre-cut-ppf-kit-for-volkswagen-golf-r-2025'
    };
    const cache=new Map(); let generation=0, available=[];
    function clearSelection(){results.replaceChildren();retry.hidden=true;button.disabled=true;}
    function loadMake(name){
      if(cache.has(name))return cache.get(name);
      const url=config.urls[name];
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),10000);
      const base=url?fetch(url,{signal:controller.signal,credentials:'omit',cache:'default'})
        .then(r=>{if(!r.ok)throw new Error('Catalog response');return r.json();}):Promise.resolve([]);
      const request=Promise.all([base,extraPromise]).then(([rows,extra])=>{
          rows=rows.concat(extra[name]||[]).map(r=>[r[0],r[1],r[2],redirects[r[3]]||r[3]]);
          if(!Array.isArray(rows)||!rows.length)throw new Error('Empty make');
          return rows.map(r=>{
            if(!Array.isArray(r)||r.length!==4||r.some(v=>typeof v!=='string')||!/^[a-z0-9-]+$/.test(r[3]))throw new Error('Invalid row');
            const m=/^(\d{4})(?:\s*-\s*(\d{4}))?(?:\s*\(([^)]+)\))?$/.exec(r[0]);
            if(!m || +(m[2]||m[1])<+m[1] || +(m[2]||m[1])-m[1]>40)throw new Error('Invalid year');
            return {from:+m[1],to:+(m[2]||m[1]),model:r[1],trim:r[2]+(m[3]?' / '+m[3]:''),years:r[0],handle:r[3]};
          });
        }).catch(e=>{cache.delete(name);throw e;}).finally(()=>clearTimeout(timeout));
      cache.set(name,request);return request;
    }
    async function chooseMake(){
      const current=++generation,selectedMake=make.value,selectedYear=year.value;
      clearSelection();available=[];reset(model,'model');reset(trim,'trim');
      if(!selectedMake){say('Select your make to continue.');return;}
      say('Loading '+selectedMake+' kits...');
      try{
        const rows=await loadMake(selectedMake);
        if(current!==generation)return;
        available=rows.filter(r=>r.from<=+selectedYear&&r.to>=+selectedYear);
        fill(model,[...new Set(available.map(r=>r.model))].sort(),'model');
        say(available.length?'Select your model and trim.':'No kits for this year. Choose another year or make.');
      }catch(e){if(current!==generation)return;retry.hidden=false;say('Could not load vehicle kits. Please retry.');}
    }
    function chooseYear(){
      ++generation;available=[];clearSelection();reset(model,'model');reset(trim,'trim');
      fill(make,(config.years[year.value]||[]).map(i=>config.makes[i]).sort(),'make');
      say('Select your make to continue.');
    }
    year.addEventListener('change',chooseYear);
    make.addEventListener('change',chooseMake);retry.addEventListener('click',chooseMake);
    function chooseModel(){
      clearSelection();const values=[...new Set(available.filter(r=>r.model===model.value).map(r=>r.trim))].sort();
      fill(trim,values,'trim');if(values.length===1)trim.value=values[0];button.disabled=!trim.value;
      say(trim.value?'Choose your kit on the next page.':'Select your trim to find the matching kit.');
    }
    model.addEventListener('change',chooseModel);
    async function restoreSelection(){
      if(root.dataset.restoreVehicle!=='true')return;
      const params=new URLSearchParams(location.search);
      const wanted={year:params.get('year'),make:params.get('make'),model:params.get('model'),trim:params.get('trim')};
      const hasOption=(field,value)=>value&&Array.from(field.options).some(option=>option.value===value);
      if(!hasOption(year,wanted.year))return;
      year.value=wanted.year;chooseYear();
      if(!hasOption(make,wanted.make))return;
      make.value=wanted.make;
      const restoreGeneration=generation+1;
      await chooseMake();
      if(generation!==restoreGeneration||!hasOption(model,wanted.model))return;
      model.value=wanted.model;chooseModel();
      if(hasOption(trim,wanted.trim))trim.value=wanted.trim;
      button.disabled=!trim.value;
      say(trim.value?'Change your vehicle details to find another kit.':'Select your trim to find the matching kit.');
    }
    trim.addEventListener('change',()=>{results.replaceChildren();button.disabled=!trim.value;say(trim.value?'Choose your kit on the next page.':'Select your trim to continue.');});
    button.addEventListener('click',e=>{
      e.preventDefault();e.stopImmediatePropagation();
      if(button.disabled||!year.value||!make.value||!model.value||!trim.value)return;
      const found=available.filter(r=>r.model===model.value&&r.trim===trim.value);
      if(found.length>0){location.assign((config.resultsPath || '/pages/choose-your-kit')+'?'+new URLSearchParams({year:year.value,make:make.value,model:model.value,trim:trim.value,handles:found.map(r=>r.handle).join(',')}).toString());return;}
      results.replaceChildren();say(found.length?'Choose the matching kit below.':'Choose your vehicle details first.');
      for(const row of found){const a=document.createElement('a');a.href='/products/'+row.handle;a.textContent=[make.value,row.model,row.years,row.trim].join(' / ');results.append(a);}
    });
    say('Choose your year and make to find your custom pre-cut PPF kit.');return true;
  }
  function start(){
    if(mount())return;
    const observer=new MutationObserver(()=>{if(mount())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});setTimeout(()=>observer.disconnect(),10000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


